var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0142 1.99902C6.49116 1.99902 2.01416 6.47602 2.01416 11.999C2.01416 17.522 6.49116 21.999 12.0142 21.999C17.0941 21.999 21.3581 18.191 21.9521 13.187C22.0161 12.638 21.6251 12.127 21.0761 12.061C20.5281 11.997 20.0161 12.388 19.9521 12.937C19.4771 16.937 16.0781 19.999 12.0142 19.999C7.59615 19.999 4.01416 16.417 4.01416 11.999C4.01416 7.58101 7.59615 3.99902 12.0142 3.99902C12.9371 3.99902 13.8512 4.16601 14.7022 4.46801C15.2222 4.65201 15.7672 4.36301 15.9522 3.84301C16.1362 3.32202 15.8781 2.74603 15.3581 2.56103C14.2941 2.18403 13.1651 1.99902 12.0142 1.99902ZM21.0141 3.99902C20.7581 3.99902 20.4901 4.08903 20.2951 4.28003L11.5761 12.874C11.3191 13.127 11.0601 13.078 10.8581 12.78L9.85815 11.311C9.55215 10.86 8.91016 10.729 8.45216 11.03C7.99316 11.331 7.86416 11.954 8.17016 12.405L9.17016 13.874C10.0712 15.203 11.8341 15.379 12.9831 14.249L21.7331 5.68701C22.1231 5.30301 22.1231 4.66403 21.7331 4.28003C21.5381 4.08803 21.2701 3.99902 21.0141 3.99902Z",
    fill: "#01C37D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/GreenTick.fe232af1bd8e302f054da1b44dffa130.svg";
export { ForwardRef as ReactComponent };